import { render, staticRenderFns } from "./borrowSampleInfoBatch.vue?vue&type=template&id=8ffc323e&"
import script from "./borrowSampleInfoBatch.vue?vue&type=script&lang=js&"
export * from "./borrowSampleInfoBatch.vue?vue&type=script&lang=js&"
import style0 from "./borrowSampleInfoBatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports